import { Directive, EventEmitter, Input, Output } from '@angular/core';

@Directive({
  selector: '[appFileread]',
  host: {
    '(change)': 'read($event)',
  },
})
export class FilereadDirective {
  @Input() fileread: string;
  @Input() filename: string;
  @Input() filedata: string;
  @Output() filereadChange: EventEmitter<any> = new EventEmitter();
  @Output() filenameChange: EventEmitter<any> = new EventEmitter();
  @Output() filedataChange: EventEmitter<any> = new EventEmitter();

  constructor() {}

  read(value: any) {
    var reader = new FileReader();
    this.filenameChange.emit(value.target.files[0].name);
    this.filedataChange.emit(value.target.files[0].name);
    reader.onload = e => {
      var arrayBuffer = reader.result;
      var binaryString = '',
        bytes = new Uint8Array(<ArrayBuffer>arrayBuffer),
        length = bytes.length;
      for (var i = 0; i < length; i++) {
        binaryString += String.fromCharCode(bytes[i]);
      }
      this.filereadChange.emit(btoa(binaryString));
    };
    reader.readAsArrayBuffer(value.target.files[0]);
  }
}
